import React from 'react';
import PropTypes from 'prop-types';

import { Field, ErrorMessage } from 'lib/form';
import { PasswordInputWithStrength } from 'components/common';

const PasswordFieldWithStrength = ({ name, onChange, ...props }) => {
  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        const _onChange = (value) => {
          form.setFieldValue(field.name, value);
          if (onChange) onChange(value);
        };

        return (
          <React.Fragment>
            <PasswordInputWithStrength
              {...props}
              name={field.name}
              type="password"
              label="Password"
              value={field.value}
              onChange={_onChange}
              onBlur={field.onBlur}
              required
              error={meta.touched && meta.error}
              helperText={<ErrorMessage name={field.name} />}
            />
          </React.Fragment>
        );
      }}
    </Field>
  );
};

PasswordFieldWithStrength.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default PasswordFieldWithStrength;
